import type { Translator } from '@porotutu/i18n'
import { type ApiError, fieldErrors } from '@porotutu/react/errors'
import { messageOf } from '../api/stops'
import { toast } from './ui/toast'

export const notifyDone = (title: string) => toast.add({ title, type: 'success' })

export const notifyBroken = (title: string) => toast.add({ title, type: 'error' })

export const notifyFailed = (t: Translator, error: ApiError | null) =>
  toast.add({ title: messageOf(t, error?.status), type: 'error' })

export const notifyRefused = (t: Translator, error: ApiError | null) => {
  const refusal = Object.values(fieldErrors(error, t))[0]

  return refusal === undefined
    ? notifyFailed(t, error)
    : toast.add({ title: refusal, type: 'error' })
}

export const notifyStale = (t: Translator) =>
  toast.add({ title: t('forms.stale'), type: 'warning' })
